import { render, staticRenderFns } from "./ModalWithFooter.vue?vue&type=template&id=373d162c&"
import script from "./ModalWithFooter.vue?vue&type=script&lang=js&"
export * from "./ModalWithFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports